export default __webpack_public_path__ + "static/media/ELBAccessLogs.7390c464.md";